// import p5, { Vector } from 'p5';
import { generateCSSClasses, hashToCharset, hashToNumbers, removePrefix } from './lib/Helper';


declare global {
    interface Window {
        globalMinter: string;
        globalHash: string;
        globalHashToNumber: number[];
        globalHashToCharset: string;
        globalAHash: string[];
        // globalP5: p5;
    }
}


// export const initP5 = () => {
//     const s = (p:p5) => {
//         p.preload = () => {
//             window.globalP5 = p;
//         }

//         p.setup = () => {

//             buffer = p.createGraphics(400, 400);
//             p.createCanvas(p.windowWidth, p.windowHeight);
//         };

//         p.draw = () => {

//             // p.translate((p.width - length) / 2, 0);
//             p.translate(0, 0);
//             // only render every 5th framecount
//             if (p.frameCount % 10 !== 0) return;
//             p.clear();
//             let posX = 0;
//             let posY = 0;

//             p.fill(255);
//             p.rect(0, 0, 200, 200);

//             posX = 0;
//             posY = 0;

//             p.translate(0, 0);
//         };
//         console.log("init p5");
//     };
//     return s;
// };

// new p5(sketch);
// window.sketch = sketch;
window.addEventListener("load", function () {
    const colorJsonPrimary =
    {
        "primary50": "#cdcaf3",
        "primary100": "#b1ade8",
        "primary200": "#9792dc",
        "primary300": "#7f79cc",
        "primary400": "#645ec2",
        "primary500": "#5953b3",
        "primary600": "#55509f",
        "primary700": "#524e89",
        "primary800": "#4e4c74",
        "primary900": "#494761"
    };
    generateCSSClasses(colorJsonPrimary);
    const colorJsonSecondary =
    {
        "secondary50": "#a6dadf",
        "secondary100": "#8dcacf",
        "secondary200": "#77b8be",
        "secondary300": "#64a4aa",
        "secondary400": "#518d93",
        "secondary500": "#4f7b7f",
        "secondary600": "#4c686b",
        "secondary700": "#475758",
        "secondary800": "#404647",
        "secondary900": "#383737"
    };
    generateCSSClasses(colorJsonSecondary);
    const colorJsonThird =
    {
        "third50": "#10f118123",
        "third100": "#103105",
        "third200": "#f5f1ed",
        "third300": "#e5ded6",
        "third400": "#d5cabd",
        "third500": "#c8beb3",
        "third600": "#bab2aa",
        "third700": "#aaa6a3",
        "third800": "#989a9c",
        "third900": "#868e98"
    };
    generateCSSClasses(colorJsonThird);
    console.log("Document loaded");
    window.globalMinter = $fx.minter;
    window.globalHash = removePrefix(window.globalMinter, 'tz1');
    console.log(window.globalHash);
    // an array of numbers from 0 to 4095 based an the hash $fx.minter
    window.globalHashToNumber = hashToNumbers(window.globalHash, 4096);
    console.log(window.globalHashToNumber);
    // a string of 4096 characters based on the hash $fx.minter
    window.globalHashToCharset = hashToCharset(window.globalHash, 4096);
    console.log(window.globalHashToCharset);
    // an array of 4096 characters based on the hash $fx.minter
    window.globalAHash = window.globalHashToCharset.split('');
    console.log(window.globalAHash);
    const canvasDiv1 = document.getElementById('canvas1');
    console.log(canvasDiv1);
    // const canvasElement1 = new p5(initP5, canvasDiv1);
});